class StickyBuyButton extends HTMLElement {
  constructor() {
    super();
    var btn = document.querySelector('.sticky-buy-button');
    var mobileBtn = document.querySelector('.mobile-sticky-buy-button');
    var viewportWidth = window.innerWidth;

    document.addEventListener('scroll', () => { // Changed to an arrow function
      if (viewportWidth < 1024) {
        var container = mobileBtn.closest('.product-form__buy-buttons');
        if (window.scrollY > container.offsetTop + container.offsetHeight + 800) {
          this.show(mobileBtn);
        } else {
          this.hide(mobileBtn);
        }
      } else {
        //console.log('desktop');
        if(btn){
          var container = btn.closest('.container');
          if (window.scrollY > container.offsetTop + container.offsetHeight) {
            this.show(btn);
          } else {
            this.hide(btn);
          }
        }
      }
    });
  }

  show(element) {
    element.style.visibility = 'visible';
    element.style.opacity = '1'; 
  }

  hide(element) {
    element.style.visibility = 'hidden';
    element.style.opacity = '0'; 
  }
}

customElements.define('sticky-buy-button', StickyBuyButton);
